import { Divider, Stack, Typography } from "@mui/material";
import TextField from '@mui/material/TextField';
import { useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import {Box} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { auth } from "../firebase-config";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase-config";
import { useEffect } from "react";
import { collection, query, where, getDocs, doc, updateDoc, getDoc } from "firebase/firestore";

const AdminHome = () => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [currentVotingTitle, setCurrentVotingTitle] = useState("");
    const [isVoting, setIsVoting] = useState(false);
    const [open_, setOpen_] = useState(false);
    const [newVoteTitle, setNewVoteTitle] = useState("");

    const handleClickOpen = () => {
      if (!isVoting) setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    const handleClickOpen_ = () => {
        if(isVoting) setOpen_(true);
      };
    
      const handleClose_ = () => {
        setOpen_(false);
      };

    const createNewVoting = () => {
        updateVoting();
        setIsVoting(true);
        setCurrentVotingTitle(newVoteTitle);
        setOpen(false);
      };

      
      async function updateVoting(){
          const docRef = doc(db, "hlasovanie", "1" );
          await updateDoc(docRef, {
              nazov: newVoteTitle,
              spustene: true
            });
        }
        
    const terminateVoting = () => {
        updateVotingTerminate();
        setIsVoting(false);
        setOpen_(false);
    };

    async function updateVotingTerminate(){
        const docRef = doc(db, "hlasovanie", "1" );
        await updateDoc(docRef, {
            spustene: false
          });

        const q = query(collection(db, "piesne"));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
            updateDoc(doc.ref, {
                AktualneHlasy: 0,
                // CelkoveHlasy: 0
            })
        });
        console.log("voting terminated");
      }

    const logoutUser = () => {
        localStorage.clear();
        signOut(auth)
        .then(() => {
        console.log("user signed out");
        navigate('/');
        })
        .catch((error) => {
        console.log("error", error);
            });
    }

    useEffect(() => {
        getData();
        
    }, []);


    async function getData() {

        const docRef = doc(db, "hlasovanie", "1");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            setIsVoting(docSnap.data().spustene);
            setCurrentVotingTitle(docSnap.data().nazov);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
          }
        
        // const q = query(collection(db, "piesne"));

        // const querySnapshot = await getDocs(q);
        // querySnapshot.forEach((doc) => {
        // // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        // });
      }

    if(localStorage.getItem("user"))
    return(
        <Stack height="100vh" direction="column" justifyContent="flex-end" spacing={3} sx={{height:'100%', alignItems: 'center', justifyContent: 'center', margin: 2}}>
            {isVoting &&
                <Typography>
                    Momentálne je spustené hlasovanie {currentVotingTitle}.
                </Typography>
            }
            {!isVoting &&
                <Typography>
                    Momentálne nie je spustené žiadne hlasovanie.
                </Typography>
            }
            
            <Box sx={{height: '50px'}}></Box>
            <Box onClick={handleClickOpen}>
                <Typography>Nové hlasovanie</Typography>
            </Box>
            <Divider style={{width:'80%'}}   />
            <Typography onClick={() => {navigate('/currentresults')}}>Výsledky aktuálneho hlasovania</Typography>
            <Divider style={{width:'80%'}}   />
            <Typography onClick={() => {navigate('/votingresults')}}>Výsledky celkového hlasovania</Typography>
            <Divider style={{width:'80%'}}  />
            <Typography onClick={handleClickOpen_} >Ukončiť aktuálne hlasovanie</Typography>
            <Divider style={{width:'80%'}} />
            <Box onClick= {() => {logoutUser()}} >
                <Typography>Odhlásiť sa</Typography>
            </Box>
        

                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Vytvoriť nové hlasovanie</DialogTitle>
                    <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Názov hlasovania"
                        fullWidth
                        variant="standard"
                        value={newVoteTitle}
                        onChange={e => setNewVoteTitle(e.target.value)}
                    />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Zrušiť</Button>
                    <Button onClick={createNewVoting} variant="outlined">Vytvoriť </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={open_} onClose={handleClose_}>
                    <DialogTitle>Ukončiť hlasovanie?</DialogTitle>
                    <DialogContent>
                        <Typography>Hlasovanie "{currentVotingTitle}" bude ukončené.</Typography>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose_}>Zrušiť</Button>
                    <Button onClick={terminateVoting} variant="outlined">Ukončiť hlasovanie</Button>
                    </DialogActions>
                </Dialog>
        </Stack>
    )
    else return(
        <Stack height="100vh" direction="column" justifyContent="flex-end" spacing={3} sx={{height:'100%', alignItems: 'center', justifyContent: 'center'}}>
            <Box sx={{height: '100px'}}></Box>
            <Typography>Neautorizovany vstup!</Typography>
        
        </Stack>
    )
}

export default AdminHome;